module.exports = __webpack_public_path__ + "media/images/bg-about-bd04b896729957d2647cb5a3ce0cb5ab.jpg";